export enum DestinationTypeEnum {
    Agent = "Agent",
    Application = "Application",
    SoftwarePackage = "SoftwarePackage",
    Firewall = "Firewall",
    ApiIntegration = "ApiIntegration",
    CmsExtension = "CmsExtension"
}